import React from "react"
import { useTranslation } from "react-i18next"

export const useBreadcrumbs = ({ mount, page, parents }) => {
  const { t } = useTranslation()

  return React.useMemo(() => {
    const links = [
      {
        title: t("homepage"),
        to: "/",
      },
    ]

    if (parents && parents.length > 0) {
      parents.forEach(bread => links.push(bread))
    } else if (mount) {
      links.push({
        title: mount.title,
        to: mount.slug,
      })
    }

    links.push({
      title: page.title,
      to: page.url,
    })

    return links
  }, [t, mount, page, parents])
}
